/**
 * Compact a CONVERTED social-feed amount once it is too wide for the row:
 * >= 1e9 -> "1.9b", >= 1e6 -> "20m". Below the threshold the caller keeps
 * its normal formatter. FLOOR the abbreviation, never round — an amount
 * that reads HIGHER than reality is the kind players screenshot (same rule
 * and rationale as formatNumberWithSuffix, QA-60249).
 *
 * Suffixes are deliberately NOT i18n'd: the i18n extractor sync writes
 * EMPTY non-en values for new keys, and an empty suffix would render
 * "GC1.9" for 1.9 BILLION — a catastrophic understatement. 'm'/'b' are
 * near-universal in gambling UIs.
 */
export const COMPACT_THRESHOLD = 1_000_000

export const formatSocialCompact = (value: number): string => {
  const tiers = [
    { value: 1e9, suffix: 'b' },
    { value: 1e6, suffix: 'm' }
  ]
  for (const { value: tier, suffix } of tiers) {
    if (value >= tier) {
      const scaled = Math.floor((value / tier) * 10) / 10
      const formatted = scaled.toFixed(1)
      return (formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted) + suffix
    }
  }
  // Caller guards on COMPACT_THRESHOLD; defensive fallthrough keeps the
  // raw integer readable rather than throwing.
  return String(Math.floor(value))
}
